import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FREE_GROUP_KEYS } from 'getting-started-shared-tasks/gettingStartedGroupKeys';
import { CTAS } from './enums';
import { jsx as _jsx } from "react/jsx-runtime";
export const getDefaultMarketingTaskGroupOverrides = () => {
  return {
    [FREE_GROUP_KEYS.crmEssentialsGroup]: {
      completion: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.crmEssentials.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketing.completion.crmEssentials.description",
          options: {
            nextHubName: I18n.text('marketing.completion.crmEssentials.nextHub')
          }
        }),
        dismissOnUnmount: true,
        cta: {
          ctaId: CTAS.COMPLETED_CRM_ESSENTIALS_MARKETING,
          scrollTargetSelector: '[data-card-locator="marketing_tools_group"]',
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "completion.crmEssentials.cta",
            options: {
              nextHubName: I18n.text('marketing.completion.crmEssentials.ctaNextHub')
            }
          })
        }
      }
    },
    [FREE_GROUP_KEYS.marketingToolsGroup]: {
      completion: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.hubTools.title",
          options: {
            hubName: I18n.text('marketing.completion.marketingTools.currentHub')
          }
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.hubTools.description",
          options: {
            nextHubName: I18n.text('marketing.completion.marketingTools.ctaNextHub')
          }
        }),
        cta: {
          ctaId: CTAS.COMPLETED_MARKETING_TOOLS,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "completion.hubTools.cta",
            options: {
              nextHubName: I18n.text('marketing.completion.marketingTools.ctaNextHub')
            }
          })
        }
      }
    }
  };
};
export const getDefaultSalesTaskGroupOverrides = () => {
  return {
    [FREE_GROUP_KEYS.crmEssentialsGroup]: {
      completion: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.crmEssentials.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "sales.completion.crmEssentials.description",
          options: {
            nextHubName: I18n.text('sales.completion.crmEssentials.nextHub')
          }
        }),
        dismissOnUnmount: true,
        cta: {
          ctaId: CTAS.COMPLETED_CRM_ESSENTIALS_SALES,
          scrollTargetSelector: '[data-card-locator="sales_tools_group"]',
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "completion.crmEssentials.cta",
            options: {
              nextHubName: I18n.text('sales.completion.crmEssentials.ctaNextHub')
            }
          })
        }
      }
    },
    [FREE_GROUP_KEYS.salesToolsGroup]: {
      completion: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.hubTools.title",
          options: {
            hubName: I18n.text('sales.completion.salesTools.currentHub')
          }
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.hubTools.description",
          options: {
            nextHubName: I18n.text('sales.completion.salesTools.ctaNextHub')
          }
        }),
        cta: {
          ctaId: CTAS.COMPLETED_SALES_TOOLS,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "completion.hubTools.cta",
            options: {
              nextHubName: I18n.text('sales.completion.salesTools.ctaNextHub')
            }
          })
        }
      }
    }
  };
};
export const getDefaultServiceTaskGroupOverrides = () => {
  return {
    [FREE_GROUP_KEYS.crmEssentialsGroup]: {
      completion: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.crmEssentials.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "service.completion.crmEssentials.description",
          options: {
            nextHubName: I18n.text('service.completion.crmEssentials.nextHub')
          }
        }),
        dismissOnUnmount: true,
        cta: {
          ctaId: CTAS.COMPLETED_CRM_ESSENTIALS_SERVICE,
          scrollTargetSelector: '[data-card-locator="service_tools_group"]',
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "completion.crmEssentials.cta",
            options: {
              nextHubName: I18n.text('service.completion.crmEssentials.ctaNextHub')
            }
          })
        }
      }
    },
    [FREE_GROUP_KEYS.serviceToolsGroup]: {
      completion: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.hubTools.title",
          options: {
            hubName: I18n.text('service.completion.serviceTools.currentHub')
          }
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.hubTools.description",
          options: {
            nextHubName: I18n.text('service.completion.serviceTools.ctaNextHub')
          }
        }),
        cta: {
          ctaId: CTAS.COMPLETED_SERVICE_TOOLS,
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "completion.hubTools.cta",
            options: {
              nextHubName: I18n.text('service.completion.serviceTools.ctaNextHub')
            }
          })
        }
      }
    }
  };
};
export const getDefaultCmsTaskGroupOverrides = () => {
  const cmsToolsGroupOverrides = {
    completion: {
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "completion.hubTools.title",
        options: {
          hubName: I18n.text('cms.completion.cmsTools.currentHub')
        }
      }),
      description: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "completion.hubTools.description",
        options: {
          nextHubName: I18n.text('cms.completion.cmsTools.ctaNextHub')
        }
      }),
      cta: {
        ctaId: CTAS.COMPLETED_CMS_TOOLS,
        text: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.hubTools.cta",
          options: {
            nextHubName: I18n.text('cms.completion.cmsTools.ctaNextHub')
          }
        })
      }
    }
  };
  return {
    [FREE_GROUP_KEYS.crmEssentialsGroup]: {
      completion: {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "completion.crmEssentials.title"
        }),
        description: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "cms.completion.crmEssentials.description",
          options: {
            nextHubName: I18n.text('cms.completion.crmEssentials.nextHub')
          }
        }),
        dismissOnUnmount: true,
        cta: {
          ctaId: CTAS.COMPLETED_CRM_ESSENTIALS_CMS,
          scrollTargetSelector: '[data-card-locator="cms_tools_group"]',
          text: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "completion.crmEssentials.cta",
            options: {
              nextHubName: I18n.text('cms.completion.crmEssentials.ctaNextHub')
            }
          })
        }
      }
    },
    [FREE_GROUP_KEYS.cmsToolsGroup]: cmsToolsGroupOverrides,
    [FREE_GROUP_KEYS.cmsToolsGroupV2]: cmsToolsGroupOverrides,
    [FREE_GROUP_KEYS.cmsToolsGroupCmsSignup]: cmsToolsGroupOverrides,
    [FREE_GROUP_KEYS.cmsToolsGroupCmsSignupV2]: cmsToolsGroupOverrides
  };
};